import React, { useEffect, useState } from 'react'
import * as S from './styles'

import { useTranslation } from 'react-i18next'

const DetailsMenuButton = ({ index, data, handler }) => {
  const { t } = useTranslation()

  const [label, setLabel] = useState('')

  useEffect(() => {
    if (!data) return
    setLabel(t(data.title))
  }, [t, data])

  return (
    data && (
      <S.DetailsMenuButtonContainer
        type="button"
        id={`btn_details_${index}`}
        color={data.menuColor ? data.menuColor : data.iconColor}
        bgColor={data.bgColor}
        onClick={() => {
          handler(index)
          document.getElementById('details').scrollIntoView()
        }}
      >
        <span>{label}</span>
      </S.DetailsMenuButtonContainer>
    )
  )
}

export default DetailsMenuButton
